import Vue from 'vue'
import Vuex from 'vuex'

import * as admin from './modules/admin'
import * as announcement from './modules/announcement'
import * as auth from './modules/auth'
import * as customer from './modules/customer'
import * as feature from './modules/feature'
import * as firmware from './modules/firmware'
import * as hardware from './modules/hardware'
import * as notification from './modules/notification'
import * as role from './modules/role'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    breadcrumbs: [],
    menusCustomerActive: false,
    showModalCustomerAboutToExpire: false,
  },
  mutations: {
    setBreadcrumbs(state, breadcrumbs) {
      state.breadcrumbs = breadcrumbs
    },
    setMenusCustomerActive(state, menusCustomerActive) {
      state.menusCustomerActive = menusCustomerActive
    },
    setShowModalCustomerAboutToExpire(state, showModalCustomerAboutToExpire) {
      state.showModalCustomerAboutToExpire = showModalCustomerAboutToExpire
    },
  },
  actions: {},
  modules: {
    auth,
    customer,
    feature,
    hardware,
    admin,
    announcement,
    notification,
    role,
    firmware,
  },
})
